import Vue from 'vue';
import PaymentTypeChoice from './payment/PaymentTypeChoice.vue';
import CCPaymentForm from './payment/method-forms/CCPaymentForm.vue';
import CreditCardSwapForm from './payment/CreditCardSwapForm.vue';
import RecurrencyPaymentForm from './payment/method-forms/RecurrencyPaymentForm.vue';
import CCInvoicePaymentForm from './payment/invoice-forms/CCInvoicePaymentForm.vue';
import PixPaymentForm from './payment/method-forms/PixPaymentForm.vue';
import PixInvoicePaymentForm from './payment/invoice-forms/PixInvoicePaymentForm.vue';
import BoletoPaymentForm from './payment/method-forms/BoletoPaymentForm.vue';
import MonthlyBillPaymentForm from './payment/method-forms/MonthlyBillPaymentForm.vue';
import BoletoGenerationForm from './payment/invoice-forms/BoletoGenerationForm.vue';
import CashPaymentForm from './payment/method-forms/CashPaymentForm.vue';
import PhysicalCCPaymentForm from './payment/method-forms/PhysicalCCPaymentForm.vue';
import DocumentSearchForm from './authentication/DocumentSearchForm.vue';
import AccessChoiceForm from './authentication/AccessChoiceForm.vue';
import AccessCodeVerificationForm from './authentication/AccessCodeVerificationForm.vue';
import PlanosCard from './planos/PlanosCard.vue'
import DataTable from './material/Datatable.vue'
import CheckboxInput from './material/CheckboxInput.vue'
import ExpansionPanel from './material/ExpansionPanel.vue'
import PersonalDataForm from './signup/PersonalDataForm.vue'
import PortugalPersonalDataForm from './signup/pt-PT/PersonalDataForm.vue'
import AddressDataForm from './signup/AddressDataForm.vue'
import PortugalAddressDataForm from './signup/pt-PT/AddressDataForm.vue'
import DependentDataForm from './signup/DependentDataForm.vue'
import PortugalDependentDataForm from './signup/pt-PT/DependentDataForm.vue'
import FreeValueSelectionForm from './signup/FreeValueSelectionForm.vue'
import SocialNumberForm from './signup/SocialNumberForm.vue'
import ChairSelectionForm from './signup/ChairSelectionForm.vue'
import TeamChoiceForm from './signup/TeamChoiceForm.vue'
import WelcomeKitForm from './signup/WelcomeKitForm.vue'
import OrderBundle from './payment/OrderBundle.vue'
import GroupedInvoicesWarning from './payment/GroupedInvoicesWarning.vue'
import RangeInput from './utils/RangeInput.vue'
import EducationalDataForm from './signup/EducationalDataForm.vue'
import ProductListing from './payment/products/ProductListing.vue'

Vue.component('payment-type-choice', PaymentTypeChoice);
Vue.component('credit-card-payment-form', CCPaymentForm);
Vue.component('credit-card-swap-form', CreditCardSwapForm);
Vue.component('recurrency-payment-form', RecurrencyPaymentForm);
Vue.component('cc-invoice-payment-form', CCInvoicePaymentForm);
Vue.component('boleto-payment-form', BoletoPaymentForm);
Vue.component('monthly-bill-payment-form', MonthlyBillPaymentForm);
Vue.component('boleto-generation-form', BoletoGenerationForm);
Vue.component('cash-payment-form', CashPaymentForm);
Vue.component('pix-payment-form', PixPaymentForm);
Vue.component('pix-invoice-payment-form', PixInvoicePaymentForm);
Vue.component('physical-cc-payment-form', PhysicalCCPaymentForm);
Vue.component('document-search-form', DocumentSearchForm);
Vue.component('access-choice-form', AccessChoiceForm);
Vue.component('access-code-verification-form', AccessCodeVerificationForm);
Vue.component('planos-card', PlanosCard);
Vue.component('data-table', DataTable);
Vue.component('checkbox-input', CheckboxInput);
Vue.component('expansion-panel', ExpansionPanel);
Vue.component('personal-data-form', PersonalDataForm);
Vue.component('portugal-personal-data-form', PortugalPersonalDataForm);
Vue.component('address-data-form', AddressDataForm);
Vue.component('portugal-address-data-form', PortugalAddressDataForm);
Vue.component('dependent-data-form', DependentDataForm);
Vue.component('portugal-dependent-data-form', PortugalDependentDataForm);
Vue.component('free-value-selection-form', FreeValueSelectionForm);
Vue.component('social-number-form', SocialNumberForm);
Vue.component('chair-selection-form', ChairSelectionForm);
Vue.component('team-choice-form', TeamChoiceForm);
Vue.component('welcome-kit-form', WelcomeKitForm);
Vue.component('order-bundle', OrderBundle);
Vue.component('grouped-invoices-warning', GroupedInvoicesWarning);
Vue.component('range-input', RangeInput);
Vue.component('educational-data-form', EducationalDataForm);
Vue.component('product-listing', ProductListing);
